import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { EntityAutoCompleteDialogComponent } from './entity-auto-complete-dialog.component';
import { EntityAutoCompleteService } from './entity-auto-complete.service';

/**
 * Mount point of the reference-picker stack, one per window.
 *
 * Each frame gets its own dialog instance, so each gets its own `EntityTableService`,
 * `PagedEntityService` and dropdown singleton: picking a reference from inside a picker
 * leaves the one below it — its filters, its search, its pending selection — untouched.
 */
@Component({
  selector: 'app-entity-auto-complete-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EntityAutoCompleteDialogComponent],
  template: `
    @for (frame of frames(); track frame.id) {
      <app-entity-auto-complete-dialog [frame]="frame" [depth]="$index" />
    }
  `,
  styles: ``
})
export class EntityAutoCompleteHostComponent {
  protected readonly frames = inject(EntityAutoCompleteService).frames;
}
